import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../lib/helpers';

import SocialButton from '../SocialButton/SocialButton';

export const Footer = ({ linksList, copyright, socials, testId = '' }) => (
  <footer
    className={twMerge(
      'bg-blue-950 dark:bg-black pt-5 px-5 pb-10 lg:p-10 mt-auto',
      'text-white text-opacity-50 text-sm lg:text-base',
    )}
  >
    <div className="flex flex-col lg:flex-row items-center justify-center w-full max-w-5xl mx-auto">
      <span className="mb-4 lg:mb-0 lg:mr-24 shrink-0">{copyright}</span>

      <ul
        className="flex flex-wrap items-center justify-between xs:justify-center
                  gap-5 xs:gap-10 lg:gap-5 mb-8 lg:mb-0 xl:ml-0"
      >
        {linksList?.map((linkList) => (
          <li key={linkList.name}>
            <Link
              to={linkList.link}
              className="hover:underline"
              {...(linkList.newTab
                ? { target: '_blank', rel: 'noreferrer' }
                : {})}
            >
              {linkList.name}
            </Link>
          </li>
        ))}
      </ul>
      <ul className="flex flex-wrap justify-center gap-4 lg:ml-auto shrink-0">
        {socials?.map((social) => (
          <li
            key={`social-${social.name}`}
            {...getTestProps(testId, 'social-icon')}
          >
            <SocialButton icon={social.icon} link={social.link} />
          </li>
        ))}
      </ul>
    </div>
  </footer>
);

Footer.propTypes = {
  /**
   * Links to your information sites
   */
  linksList: PropTypes.any,
  /**
   * You can add your own company name
   */
  copyright: PropTypes.any,
  /**
   * Editable socials with directly links for your sites
   */
  socials: PropTypes.any,
  /**
   * Component test id
   */
  testId: PropTypes.string,
};
